<template>
  <div :class="['edu-navbar-area navbar-area', { 'is-sticky': isSticky }]">
    <div class="edumim-nav">
      <div class="container">
        <router-link to="/" class="d-block">
          <nav class="navbar navbar-expand-lg navbar-light">
            <img
              src="../../assets/img/logo/logo-kemenhub.png"
              alt="logo"
              class="logo-top"
            />
            <img src="../../assets/img/logo/logo-may.png" alt="logo" class="logo-top" />
            <img
              src="../../assets/img/logo/logo-irclass.png"
              alt="logo"
              class="logo-top"
            />
            <img src="../../assets/img/logo/logo-50.png" alt="logo" class="logo-top" />
            <img
              src="../../assets/img/logo/logo-telanusa.png"
              alt="logo"
              class="logo-top"
            />
            <img src="../../assets/img/logo/logo-tmt.png" alt="logo" class="logo-top" />
          </nav>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "MainNavbar",
  data() {
    return {
      isSticky: false,
      active: false,
      button_active_state: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      const scrollPos = window.scrollY;
      // this.isSticky = scrollPos >= 100;
    });
  },
});
</script>
<style scoped>
.logo-top {
  width: auto;
  height: 80px;
}
.navbar-area,
.navbar-area.is-sticky {
  background-color: #0c1327 !important;
}
@media only screen and (max-width: 767px) {
  .logo-top {
    width: auto;
    height: 40px;
  }
}
</style>
